import React from 'react';
import { useNavigate} from "react-router-dom";
import "./notFoundScreen.scss";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import LottieFileGenarationComponent
    from "../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../constants";
import {CommonService} from "../../shared/services";

export interface NotFoundScreenProps {
    backUrl?: string
}

const NotFoundScreen = (props: NotFoundScreenProps) => {
    const navigate = useNavigate();
    return (
        <div className={'not-found-screen'}>
            <div className={'lottie-wrapper'}>
                <LottieFileGenarationComponent
                    height={'200px'}
                    width={'200px'}
                    loop={true}
                    autoplay={true}
                    animationData={ImageConfig.notFoundLottie}/>
            </div>
            <div className={'not-found-title'}>
                Error 404! Page not found on server.
            </div>
            <div className={'not-found-description'}>
                The page you requested does not exist. Contact the support team for assistance.
            </div>
            <div className={'not-found-page-action-wrapper'}>
                <ButtonComponent
                    handleClick={() => navigate(CommonService._routeConfig.Dashboard())}
                    variant={"contained"}
                    color={"primary"}
                >
                    Back to Dashboard
                </ButtonComponent>
            </div>
        </div>

    )
};

export default NotFoundScreen;
